import { Instance, SnapshotOut, types } from "mobx-state-tree"

import { OrderTrackingStoreModel } from "./OrderTrackingStore"

/**
 * A RootStore model.
 */
export const RootStoreModel = types.model("RootStore").props({
  orderTrackingStore: types.optional(OrderTrackingStoreModel, {}),
})

/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> {}
/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
